import { render, staticRenderFns } from "./stepThr.vue?vue&type=template&id=1b38824f&scoped=true&"
import script from "./stepThr.vue?vue&type=script&lang=js&"
export * from "./stepThr.vue?vue&type=script&lang=js&"
import style0 from "./stepThr.vue?vue&type=style&index=0&id=1b38824f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38824f",
  null
  
)

export default component.exports